import UilFacebook from '@iconscout/react-unicons/icons/uil-facebook-f'
import UilLinkedin from '@iconscout/react-unicons/icons/uil-linkedin'
import UilInstagram from '@iconscout/react-unicons/icons/uil-instagram'
import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const Footer = () => {

    const [ref, inView] = useInView({ triggerOnce: true })

    return (
        <motion.div className="select-none p-6 lg:px-12 lg:mt-6 lg:pb-6 text-zinc-600 dark:text-zinc-400 text-sm space-y-6 border-t border-slate-200 dark:border-slate-800/80 transition-colors duration-300" ref={ref} initial={{ y: 10, opacity: 0 }} animate={inView? { y: 0, opacity: 1 }: {}} exit={{ y: 10, opacity: 0 }} transition={{ duration: 0.5 }}>
            <div className="flex flex-col lg:flex-row space-y-8 lg:space-y-0 items-top justify-between">
                <div className="flex flex-col space-y-4 lg:w-3/12">
                    <h2 className="text-2xl text-forest dark:text-emerald-400 font-bold logo-font">Jibu Labs</h2>
                    <p className="font-roboto font-light text-sm text-zinc-500 dark:text-zinc-400">
                        By leveraging our state-of-the-art AI strategy, design, and intelligent technology engineering, we deliver game-changing agentic solutions for our clients worldwide.
                    </p>
                    <h3 className="text-sm font-semibold text-zinc-800 dark:text-zinc-200 uppercase tracking-wider">Social Media</h3>
                    <div className="flex flex-row space-x-4 text-zinc-500 dark:text-zinc-400">
                        <motion.a className="hover:text-forest dark:hover:text-emerald-400 transition-colors" whileHover={{ scale: 1.2 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} href="https://www.linkedin.com/company/jibu-labs/" target="blank">
                            <UilLinkedin size={20} color="currentColor"></UilLinkedin>
                        </motion.a>
                        <motion.a className="hover:text-forest dark:hover:text-emerald-400 transition-colors" whileHover={{ scale: 1.2 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} href="https://www.facebook.com/jibulab" target="blank">
                            <UilFacebook size={20} color="currentColor"></UilFacebook>
                        </motion.a>
                        <motion.a className="hover:text-forest dark:hover:text-emerald-400 transition-colors" whileHover={{ scale: 1.2 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} href="https://www.instagram.com/jibulabs/" target="blank">
                            <UilInstagram size={20} color="currentColor"></UilInstagram>
                        </motion.a>
                    </div>
                </div>
                <div className="flex flex-col space-y-4">
                    <h2 className="text-sm font-semibold text-zinc-800 dark:text-zinc-200 uppercase tracking-wider">Our Capabilities</h2>
                    <ul className="list-none space-y-2 font-light text-zinc-500 dark:text-zinc-400">
                        <li>
                            <a href="strategy" className="hover:text-forest dark:hover:text-emerald-400 transition-colors">Enterprise AI</a>
                        </li>
                        <li>
                            <a href="design" className="hover:text-forest dark:hover:text-emerald-400 transition-colors">Mobile AI</a>
                        </li>
                        <li>
                            <a href="technology" className="hover:text-forest dark:hover:text-emerald-400 transition-colors">SMB AI</a>
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col space-y-4">
                    <h2 className="text-sm font-semibold text-zinc-800 dark:text-zinc-200 uppercase tracking-wider">AI Methodology</h2>
                    <ul className="list-none space-y-2 font-light text-zinc-500 dark:text-zinc-400">
                        <li>
                            <a href="design-thinking" className="hover:text-forest dark:hover:text-emerald-400 transition-colors">AI Strategy</a>
                        </li>
                        <li>
                            <a href="ux-research" className="hover:text-forest dark:hover:text-emerald-400 transition-colors">Model Verification</a>
                        </li>
                        <li>
                            <a href="ui-design" className="hover:text-forest dark:hover:text-emerald-400 transition-colors">Agentic UX</a>
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col space-y-4">
                    <h2 className="text-sm font-semibold text-zinc-800 dark:text-zinc-200 uppercase tracking-wider">Jibu Labs</h2>
                    <ul className="list-none space-y-2 font-light text-zinc-500 dark:text-zinc-400">
                        <li>
                            <a href="about" className="hover:text-forest dark:hover:text-emerald-400 transition-colors">About Us</a>
                        </li>
                        <li>
                            <a href="pricing" className="text-forest dark:text-emerald-400 hover:text-forest-hover font-medium">Pricing</a>
                        </li>
                        <li>
                            <a href="contact" className="hover:text-forest dark:hover:text-emerald-400 transition-colors">Contact Us</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className='border-b border-slate-200 dark:border-slate-800/80'></div>
            
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 items-center justify-between text-zinc-500 dark:text-zinc-400 text-xs">
                <div>&copy; {new Date().getFullYear()} Jibu Labs LLC | All Rights Reserved.</div>
                <ul className="list-none flex space-x-4">
                    <li>
                        <a href="terms-of-service" className="hover:text-forest dark:hover:text-emerald-400 transition-colors">Terms of Service</a>
                    </li>
                    <li>
                        <a href="privacy-policy" className="hover:text-forest dark:hover:text-emerald-400 transition-colors">Privacy Policy</a>
                    </li>
                </ul>
            </div>

        </motion.div>
    )
}

export default Footer